<template>
  <div class="order-container">
    <div
      v-if="!detail || detail === {}"
      style="text-align: center;margin-top:100px"
    >
      <img src="/image/static/img/nodata.png" />
      <p class="no-data">暂无数据！</p>
    </div>
    <div v-else>
      <el-collapse v-model="activeName">
        <el-row :gutter="5">
          <!-- 左边栏数据 -->
          <el-col :span="24">
            <el-card shadow="hover">
              <el-collapse-item name="1">
                <template #title>
                  <div>
                    <span
                      style="font-size: 1rem;color: #5a5a5a;font-family: 'Muli', sans-serif;"
                    >
                      <span>{{ detail.carrierName }}</span>
                      <el-divider direction="vertical"></el-divider>
                      <span>{{ detail.orgName }}</span>
                    </span>
                    <el-divider direction="vertical"></el-divider>
                    <span>运单状态：{{ detail.wayBillStatusName }}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>运单号：{{ detail.waybillNo }}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>创建人：{{ detail.createByName }} </span>
                    <el-divider direction="vertical"></el-divider>
                    <span>创建时间：{{ detail.createTime }} </span>
                  </div>
                </template>
                <div style="font-size: 13px;line-height:30px">
                  <div class="mt-3">
                    <span
                      >总件数：<label style="color: #007bff">{{
                        detail.totQty
                      }}</label>
                    </span>
                    <el-divider direction="vertical"></el-divider>
                    <span
                      >总重量：<label style="color: #007bff">{{
                        detail.totPayWeight
                      }}</label>
                    </span>
                    <el-divider direction="vertical"></el-divider>
                    <span
                      >总体积：<label style="color: #007bff">{{
                        detail.totPayVolume
                      }}</label>
                    </span>
                    <el-divider direction="vertical"></el-divider>
                    <span
                      >总货值：<label style="color: #007bff">{{
                        detail.totValue
                      }}</label></span
                    >
                    <el-divider direction="vertical"></el-divider>
                    <span>备注：{{ detail.wayBillRemarks }}</span>
                    <br />
                  </div>
                </div>
                <div class="mt-4" style="font-size: 13px;">
                  <el-row :gutter="5">
                    <el-col :span="12">
                      <div style="font-size: 13px;">
                        <div class="side-frame">
                          <span style="font-size: 14px; color: #606266"
                            >始发地信息
                          </span>
                        </div>
                        <div v-if="!detail.origin" style="text-align: center;">
                          <img src="/image/static/img/nodata.png" />
                          <p class="no-data">
                            暂无始发地信息！
                          </p>
                        </div>
                        <div v-else style="line-height:30px">
                          <span>地址：{{ detail.origin }}</span>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div style="font-size: 13px;">
                        <div class="side-frame">
                          <span style="font-size: 14px; color: #606266"
                            >目的地信息
                          </span>
                        </div>
                        <div v-if="!detail.dest" style="text-align: center;">
                          <img src="/image/static/img/nodata.png" />
                          <p class="no-data">
                            暂无目的地信息！
                          </p>
                        </div>
                        <div v-else style="line-height:30px">
                          <span>地址：{{ detail.dest }}</span>
                          <br />
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div class="mt-4" style="font-size: 13px;">
                  <div class="side-frame">
                    <span style="font-size: 14px; color: #606266"
                      >费用明细
                    </span>
                  </div>
                  <div style="line-height:30px">
                    <el-row :gutter="5">
                      <el-col :span="8">
                        <span>合同编号：{{ detail.contractCarrierNo }}</span>
                      </el-col>
                      <el-col :span="8">
                        <span
                          >合同名称：{{ detail.contractCarrierName }}</span
                        ></el-col
                      >
                      <el-col :span="5">
                        <span>计费单位：{{ detail.v_chargeUnit }}</span>
                      </el-col>
                      <el-col :span="3">
                        <span>单价：{{ detail.basePrice || 0 }}</span>
                      </el-col>
                    </el-row>

                    <el-row :gutter="5">
                      <el-col :span="8">
                        <span>应付运费合计：{{ detail.payAmount || 0 }}</span>
                      </el-col>
                      <el-col :span="8">
                        <span
                          >应付费用合计：{{ detail.payFeeAmount || 0 }}</span
                        >
                      </el-col>
                      <el-col :span="8">
                        <span>应付合计：{{ detail.payTotalAmount || 0 }}</span>
                      </el-col>
                    </el-row>
                    <el-row :gutter="5">
                      <el-col :span="8">
                        <span
                          >合同运费合计：{{
                            detail.contractFreightAmount || 0
                          }}</span
                        >
                      </el-col>
                      <el-col :span="8">
                        <span
                          >合同费用合计：{{
                            detail.contractFeeAmount || 0
                          }}</span
                        >
                      </el-col>
                      <el-col :span="8">
                        <span
                          >合同应付合计：{{ detail.contractAmount || 0 }}</span
                        >
                      </el-col>
                    </el-row>
                  </div>
                </div>

                <div class="mt-4" style="font-size: 13px;">
                  <div class="side-frame">
                    <span style="font-size: 14px; color: #606266"
                      >合同附加费
                    </span>
                  </div>
                  <div style="line-height:30px">
                    <el-row :gutter="5">
                      <el-col :span="8">
                        <span>送货费：{{ detail.payFeeNameOne }}</span>
                      </el-col>
                      <el-col :span="8">
                        <span>理货费：{{ detail.payFeeNameTwo }}</span></el-col
                      >
                      <el-col :span="5">
                        <span>空箱笼返回费：{{ detail.payFeeNameThree }}</span>
                      </el-col>
                    </el-row>

                    <el-row :gutter="5">
                      <el-col :span="8">
                        <span
                          >拼点送货加收费用：{{ detail.payFeeNameFour }}</span
                        >
                      </el-col>
                      <el-col :span="8">
                        <span>放空费：{{ detail.payFeeNameFive }}</span>
                      </el-col>
                    </el-row>
                  </div>
                </div>
              </el-collapse-item>
            </el-card>
          </el-col>
        </el-row>
        <el-row>
          <el-card shadow="hover" class="mt-2">
            <el-collapse-item name="3">
              <template #title>
                <h6>调度订单列表</h6>
              </template>
              <div v-if="!detail.dispatchList" style="text-align: center;">
                <img src="/image/static/img/nodata.png" />
                <p class="no-data">暂无运单数据！</p>
              </div>
              <div v-else>
                <dispatch-table :tableData="detail.dispatchList" />
              </div>
            </el-collapse-item>
          </el-card>
        </el-row>
      </el-collapse>
    </div>
  </div>
</template>
<script>
import DispatchTable from './dispatch-table'
export default {
  name: 'carriage-waybill-detail-page',
  components: { DispatchTable },
  props: {
    no: {
      type: String,
      default: () => null,
    },
  },
  data() {
    return {
      isShowMainPanel: false,
      isEvent: true,
      isPickup: true,
      isReceiving: true,
      detail: {},
      activeName: ['1', '2', '3', '4', '5'],
    }
  },
  watch: {
    no: {
      handler(no) {
        if (no) {
          this.loadData(no)
        }
      },
      immediate: true,
    },
    params: {
      handler(params) {
        if (params.no) {
          this.loadData(params.no)
        }
      },
      immediate: true,
    },
  },
  computed: {
    params() {
      return this.$route.params
    },
  },
  methods: {
    loadData(no) {
      this.$api
        .carriageWaybillDetailOrderListApi({
          waybillCode: no,
        })
        .then((res) => {
          console.log('res.body', res.body)
          this.detail = res.body
        })
    },
    // onImagePreview(index) {
    //   // 点击大图显示图片预览组件
    //   const viewer = this.$el.querySelector('.images').$viewer
    //   viewer.view(index)
    //   viewer.show()
    // },
  },
}
</script>
<style lang="scss" scoped>
.timeline-timestamp {
  color: gray;
  margin-right: 10px;
}

.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
</style>
<style scoped>
.block >>> ul.el-timeline {
  padding: 0;
}

.order-container >>> .el-collapse,
.order-container >>> .el-collapse-item__wrap,
.order-container >>> .el-collapse-item__header {
  border: 0px;
}

.order-container >>> ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
.order-container >>> ::-webkit-scrollbar-thumb {
  background-color: #a1a3a9;
  border-radius: 3px;
}

.order-container >>> .el-card__body {
  padding: 5px 20px 20px 20px;
}

.order-container >>> .el-collapse-item__content {
  padding-bottom: 0;
}
</style>
